const defaultTitle = (data) => data && data.hasOwnProperty('title') ? data.title : data;
export { defaultTitle };
//# sourceMappingURL=formatters.js.map